import request from "@/utils/request";

// 查询表单组
export function getFormGroups(data) {
  return request({
    url: "OA/approvalFlowTemplate/list",
    method: 'post',
    data,
  });
}

// 表单排序
export function groupItemsSort(param) {
  return request({
    url: "admin/form/group/sort",
    method: "put",
    data: param
  });
}

// 更新表单组
export function updateGroup(param, method) {
  return request({
    url: "admin/form/group",
    method: method,
    params: param
  });
}

// 获取表单分组
export function getGroup() {
  return request({
    url: "admin/form/group/list",
    method: "get"
  });
}

// 设置模板状态
export function updateForm(data) {
  return request({
    url: "OA/approvalFlowTemplate/update",
    method: "post",
    data
  });
}

// 新建模板
export function createForm(data) {
  return request({
    url: "OA/approvalFlowTemplate/insert",
    method: "post",
    data: data
  });
}
export function createForm3(data) {
  return request({
    url: "Tpt/SavetTeamTpt",
    method: "post",
    data: data
  });
}

// 查询表单详情
export function getFormDetail(params) {
  return request({
    url: "OA/approvalFlowTemplate/detail",
    method: "get",
    params
  });
}
export function getFormDetail3(params) {
  return request({
    url: "OA/approvalFlowTemplate/detail",
    method: "get",
    params
  });
}
// 更新表单详情
export function updateFormDetail(data) {
  return request({
    url: "OA/approvalFlowTemplate/update",
    method: "post",
    data
  });
}
export function updateFormDetail3(data) {
  return request({
    url: "Tpt/SavetTeamTpt",
    method: "post",
    data: data
  });
}

// 删除表单
export function deletForm(params) {
  return request({
    url: "OA/approvalFlowTemplate/delete",
    method: "get",
    params
  });
}

// 提交单据
export function SubmitInstance(data) {
  return request({
    url: "OA/approvalInstance/insert",
    method: "post",
    data
  });
}

// 获取我的审批记录
export function GetMyFlowInstancePage(data) {
  return request({
    url: "OA/approvalInstance/list",
    method: "post",
    data
  });
}


// 获取审批记录详情
export function GetFlowInstance(data) {
  return request({
    url: "OA/approvalInstance/detail",
    method: "post",
    data
  });
}
// 获取审批记录详情(抄送给我)
export function GetFlowInstanceCC(data) {
  return request({
    url: "OA/approvalInstance/CCtoDetail",
    method: "post",
    data
  });
}

// 审批单据
export function VerifyInstance(data) {
  return request({
    url: "OA/approvalFlowOpeaterec/update",
    method: "post",
    data
  });
}

// 获取指定实例的操作记录
export function GetOpeateRecList(data) {
  return request({
    url: "OA/approvalFlowOpeaterec/list",
    method: "post",
    data
  });
}

// 获取全部审批记录
export function GetFlowInstancePage(data) {
  return request({
    url: "OA/approvalInstance/list",
    method: "post",
    data
  });
}

// 删除单据
export function DeleteInstance(params) {
  return request({
    url: "OA/approvalInstance/delete",
    method: "get",
    params
  });
}

// 判断当前用户针对模板是否存在起草中的实例
export function ExistInstance(data) {
  return request({
    url: "FlowInstance/ExistInstance",
    method: "post",
    data
  });
}

// 生成实例
export function GenerateInstance(data) {
  return request({
    url: "FlowInstance/GenerateInstance",
    method: "post",
    data
  });
}

// 初始化并加载审批节点（主要用于起草时进行加载）
export function InitFlowNode(data) {
  return request({
    url: "OA/approvalFlowNode/getNodes",
    method: "post",
    data
  });
}

// 设置自选审批人
export function SetCustomVerifiy(data) {
  return request({
    url: "FlowInstance/SetCustomVerifiy",
    method: "post",
    data
  });
}

// 判断是否存在正在审核中的变更申请
export function ExistChangeApply(params) {
  return request({
    url: "TeMember/ExistChangeApply",
    method: "get",
    params
  });
}

// 获取正在变更申请
export function GetChangeApply(params) {
  return request({
    url: "TeMember/GetChangeApply",
    method: "get",
    params
  });
}

// 获取正在变更申请
export function GetApply(params) {
  return request({
    url: "TeMember/GetApply",
    method: "get",
    params
  });
}

// 生成成员变更申请信息
export function GenerateMakeCard(data) {
  return request({
    url: "TeMember/GenerateMakeCard",
    method: "post",
    data
  });
}

// 发起转正申请
export function SubmitVerity(data) {
  return request({
    url: "TeMember/SubmitVerity",
    method: "post",
    data
  });
}

// 获取制证申请详情
export function GetMakeCard(params) {
  return request({
    url: "MakeCard/GetMakeCard",
    method: "get",
    params
  });
}
//
// 撤回跟重新发起
export function goback(data) {
  return request({
    url: "OA/approvalFlowOpeaterec/reApproval",
    method: "post",
    data
  });
}

// 上下班时间查询
export function commuter(data) {
  return request({
    url: "OA/attendance/rule/commuter/user",
    method: "post",
    data
  });
}

export default {
  getFormGroups,
  groupItemsSort,
  createForm,
  getFormDetail,
  updateGroup,
  getGroup,
  updateForm,
  updateFormDetail,
  deletForm,
  updateFormDetail3,
  getFormDetail3,
  createForm3,
  SubmitInstance,
  GetMyFlowInstancePage,
  GetFlowInstance,
  VerifyInstance,
  GetOpeateRecList,
  GetFlowInstancePage,
  DeleteInstance,
  ExistInstance,
  GenerateInstance,
  InitFlowNode,
  SetCustomVerifiy,
  ExistChangeApply,
  GetChangeApply,
  GenerateMakeCard,
  SubmitVerity,
  GetMakeCard,
  GetApply
};
